export default __webpack_public_path__ + "static/media/051-monkey.9191d5a5.svg";